// @flow
import AnotherUserLoggedIn from './another-user-logged-in';

export default AnotherUserLoggedIn;
